import React, { useRef } from "react";
import { Box, Button, Checkbox, Divider, Grid, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useDrag, useDrop } from "react-dnd";
import { DND_ITEM_TYPES } from "../supplyTableRow";

const HistorySidebarRow = ({ product, index, selected, onSelect, onShow, onMoveItem, onDragBegin, onDragCancel }) => {
  const ref = useRef(null);

  const [{ isDragging }, drag] = useDrag(() => ({
    type: DND_ITEM_TYPES.HIDDEN_ROW,
    item: () => {
      onDragBegin?.();
      return { product, index, type: DND_ITEM_TYPES.HIDDEN_ROW };
    },
    end: () => {
      // Always reopen sidebar after drag ends (was closed during drag)
      onDragCancel?.();
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [product, index, onDragBegin, onDragCancel]);

  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: DND_ITEM_TYPES.HIDDEN_ROW,
    hover: (draggedItem, monitor) => {
      if (!ref.current) return;
      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) return;

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the item's height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      // Time to actually perform the action
      if (onMoveItem) {
        onMoveItem(dragIndex, hoverIndex);
      }

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      draggedItem.index = hoverIndex;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }), [index, onMoveItem]);

  // Combine drag and drop refs
  drag(drop(ref));

  const displaySize = [
    product.rankName,
    product.productClassName,
    product.packingName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <Grid
        container
        alignItems="center"
        ref={ref}
        sx={{
          py: 0.5,
          opacity: isDragging ? 0.5 : 1,
          cursor: "grab",
          "&:active": { cursor: "grabbing" },
          bgcolor: isDragging ? "action.hover" : isOver ? "primary.50" : "transparent",
          borderRadius: 1,
          borderTop: isOver ? "2px solid" : "2px solid transparent",
          borderColor: isOver ? "primary.main" : "transparent",
          transition: "background-color 0.15s ease",
        }}
        spacing={0.5}
      >
        <Grid item xs={0.4} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <DragIndicatorIcon sx={{ fontSize: 16, color: "grey.400", cursor: "grab" }} />
        </Grid>
        {/* <Grid item xs={0.6}>
          <Checkbox
            size="small"
            checked={selected}
            onChange={onSelect}
            sx={{ p: 0.25 }}
          />
        </Grid> */}
        <Grid item xs={2.8}>
          <Typography variant="body2" noWrap title={product.productName} sx={{ fontSize: 14 }}>
            {product.productName}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" noWrap title={product.originName} sx={{ fontSize: 14 }}>
            {product.originName}
          </Typography>
        </Grid>
        <Grid item xs={2.2}>
          <Typography variant="body2" noWrap title={displaySize} sx={{ fontSize: 14 }}>
            {displaySize}
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="body2" noWrap sx={{ fontSize: 14 }}>
            {product.weight || ""}
            {product.weightUnitName}
          </Typography>
        </Grid>
        {/* <Grid item xs={2.5} sx={{ textAlign: "center" }}>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={onShow}
            startIcon={<AddIcon sx={{ fontSize: 14 }} />}
            sx={{
              fontSize: 12,
              py: 0.25,
              px: 0.75,
              minWidth: "auto",
            }}
          >
            表示
          </Button>
        </Grid> */}
      </Grid>
      <Divider variant="fullWidth" sx={{ opacity: 0.3 }} />
    </>
  );
};

export default HistorySidebarRow;
